/**
 * EventManager — pub/sub event bus used for all cross-service and
 * service-to-view communication in the gps-tracker app.
 *
 * Copied verbatim from the 3dPresenter2 engine
 * (/Volumes/DatenAP/Code/3dPresenter2/src/engine/core/EventManager.ts)
 * to keep the pattern consistent with Alex's canonical TS/OOP style.
 */
export class EventManager {
    constructor() {
        this._listeners = new Map();
    }
    /** Add an event listener */
    on(event, callback) {
        if (!this._listeners.has(event)) {
            this._listeners.set(event, []);
        }
        this._listeners.get(event).push(callback);
    }
    /** Add a one-shot listener — fires once then auto-removes itself */
    once(event, callback) {
        const wrapper = (...args) => {
            this.off(event, wrapper);
            callback(...args);
        };
        this.on(event, wrapper);
    }
    /** Remove an event listener */
    off(event, callback) {
        if (!this._listeners.has(event))
            return;
        const callbacks = this._listeners.get(event);
        const index = callbacks.indexOf(callback);
        if (index !== -1) {
            callbacks.splice(index, 1);
        }
    }
    /** Emit an event to all listeners */
    emit(event, ...args) {
        if (!this._listeners.has(event))
            return;
        const callbacks = this._listeners.get(event);
        callbacks.forEach((callback) => {
            try {
                callback(...args);
            }
            catch (error) {
                console.error(`Error in event listener for '${event}':`, error);
            }
        });
    }
    /** Remove all listeners for an event, or all listeners if no event given */
    removeAllListeners(event) {
        if (event) {
            this._listeners.delete(event);
        }
        else {
            this._listeners.clear();
        }
    }
    /** Get listener count for an event */
    listenerCount(event) {
        return this._listeners.get(event)?.length || 0;
    }
}
//# sourceMappingURL=EventManager.js.map